import { LuLinkedin, LuInstagram, LuMapPin, LuPhone, LuWhatsapp } from "react-icons/lu";
import styles from "./styles.module.css"
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Footer(){
    const navigate = useNavigate()
    return(
        <footer className={styles.footerContainer + " " + styles.border}>
            <div className={styles.contentContainer}>
                <div className={styles.columnWrapper}>
                    <div 
                        className={styles.contentItem} 
                        style={{cursor: "pointer"}}
                        onClick={() => window.location.href = `https://maps.app.goo.gl/Ns7Ngw1BVXSxYCBB7`}>
                            <LuMapPin size={20} style={{minWidth: "20px"}}/>
                            <div>SCS QUADRA 01 BLOCO E LOTE 30 LOJAS 04 E 05 - Asa Sul, Brasília - DF, 70303-900, Brasil.</div>
                    </div>
                    <div 
                        className={styles.contentItem} 
                        style={{cursor: "pointer"}}
                        onClick={() => window.location.href = "tel:+556130815555"}>
                            <LuPhone size={20} style={{minWidth: "20px"}}/>
                            <div>+55 (61) 3081-5555</div>
                    </div>
                </div>
                <div className={styles.columnWrapper + " " + styles.rightSide}>
                    <div className={styles.contentItem}>
                        <LuLinkedin
                            style={{minWidth: "20px"}}
                            cursor={"pointer"}
                            onClick={() => window.open(`https://www.linkedin.com/company/guerra-finan%C3%A7as-&-neg%C3%B3cios/posts/`, '_blank')} 
                            size={20} 
                        />
                        <LuInstagram 
                            style={{minWidth: "20px"}}
                            cursor={"pointer"}
                            size={20}
                            onClick={() => window.open(`https://www.instagram.com/guerraconsorcios/`, '_blank')}
                        />
                        <FaWhatsapp
                            style={{minWidth: "20px"}}
                            cursor={"pointer"}
                            size={20}
                            onClick={() => window.open(`https://wa.me/+5561992490548`, '_blank')}
                        />
                    </div>
                    <div className={styles.siteMap}>
                        <a onClick={() => navigate("/simulador/AU")}>Simulador</a> |
                        <a onClick={() => window.location.href = `https://www.guerraconsorcios.com.br/`}> Site</a> |
                        <a onClick={() => window.location.href = `https://www.guerraconsorcios.com.br/contato/`}> Contato</a>
                    </div>
                    
                </div>
                
            </div>
            <div className={styles.copyright}>
                © Guerra Consórcios. Todos os Direitos Reservados.
            </div>
        </footer>
    )
}

export default Footer;